var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"logotype",style:(_vm.vars)},[_c('svg-logo',{staticClass:"logotype__image",attrs:{"title":"Logo makesense"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }